import React from 'react';
import { Hero } from './components/sections/Hero';
import { Testimonials } from './components/sections/Testimonials';
import { Problem } from './components/sections/Problem';
import { Tomos } from './components/sections/Tomos';
import { Bonos } from './components/sections/Bonos';
import { Offer } from './components/sections/Offer';
import { PlanMaestro } from './components/sections/PlanMaestro';
import { MoreTestimonials } from './components/sections/MoreTestimonials';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { CostOfInaction } from './components/sections/CostOfInaction';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans text-charcoal" data-id="element-0" data-mp="23vkvuhy9gblr">
      <Hero data-id="element-1" data-mp="23t8eo70bu59r" />
      <main data-id="element-2" data-mp="3ijxnsm94vshs">
        <Testimonials data-id="element-3" data-mp="3ik7jmqgv0tve" />
        <Problem data-id="element-4" data-mp="3iiwf2oflbi38" />
        <Tomos data-id="element-5" data-mp="3ijfv1zlojwem" />
        <Bonos data-id="element-6" data-mp="3ihv2gfixenje" />
        <Offer data-id="element-7" data-mp="3mlja0y7k5j4n" />
        <PlanMaestro data-id="element-8" data-mp="3mlat8v8bdto6" />
        <MoreTestimonials data-id="element-9" data-mp="3mkhmhu9cv461" />
        <Guarantee data-id="element-10" data-mp="3mjq1tehaqquj" />
        <Faq data-id="element-11" data-mp="3mj6hxs835sdv" />
        <CostOfInaction data-id="element-12" data-mp="3rc9i4j7dc031" />
        <FinalCta data-id="element-13" data-mp="3rbznujfaj6rj" />
      </main>
      <Footer data-id="element-14" data-mp="3rcsuzli5vya7" />
      <PurchaseNotifications data-id="element-15" data-mp="3reccfffk0fdk" />
    </div>;
}